import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useRawMaterialMasterHook from './raw-material-master.hook';
import * as styled from './raw-material-master.styles';
import themes from './themes';

import EditableTable from '../../components/edit-table';

export interface RawMaterialMasterProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = RawMaterialMasterProps & ThemeOverride;

function RawMaterialMaster(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t,
          dataForColumns,
          columnNames,
          handleSaveAndDeleteFromTable
        } = useRawMaterialMasterHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.RawMaterialMaster className={`raw-material-master ${className ?? ''}`.trim()} style={style}>
        {dataForColumns.length > 0 ?
          <EditableTable
            tableData={dataForColumns}
            tableColumns={columnNames}
            Table_Header='MATERIAL EDITOR'
            hiddenColumns={['displayseq', 'remarks', 'isactive']}
            handleSave={handleSaveAndDeleteFromTable}
            showActions_ext = {true}
            allowSelection = {false}
            saveReturnType={'row'}
            onlyAddableFields={['materialcode', 'materialname']}
          />
          :
          (
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', width: '100%', fontSize: "18px"}}>
              <h2>{t('no-record-found')}</h2>
            </div>
          )
        }
      </styled.RawMaterialMaster>
    </ThemeProvider>
  );
}

export default memo(RawMaterialMaster) as unknown as typeof RawMaterialMaster;
